


























import Vue from 'vue'
import ExtensionOption from '@/types/ExtensionOption.interface'
import extensionsMixin from '@/mixins/extension-options-mixin'
import IListAction, { IListActionType } from '@/types/components/IListAction.interface'
import Button from '@/types/components/Button.interface'
import IListTile from '@/types/components/IListTile.interface'
import IListIcon, { IListIconType } from '@/types/components/IListIcon.interface'
export default Vue.extend({
    mixins: [extensionsMixin],
    data() {
        return {
            extensionsPlaceholder: {
                content:
                    'Not sure how to use Custom Fields? Check out our article below to learn more.',
                img: 'noCustomers',
                button: {
                    color: 'primary',
                    text: 'Learn Custom Fields',
                    callback: () =>
                        window.open(
                            `${process.env.VUE_APP_URL_LEARN}/en/articles/4527055-how-to-create-and-edit-custom-fields`,
                            this.$store.getters.isApp ? '_system' : '_blank'
                        )
                }
            },
            //  Determines if we display content
            mounted: false,
            toolbar: {
                title: 'Custom Fields',
                left: [
                    {
                        title: 'Back',
                        icon: 'mdi-chevron-left',
                        back: '/settings',
                        tooltip: 'Back',
                        permission: 0
                    }
                ],
                right: []
            }
        }
    },
    beforeDestroy() {
        //  Unset our selected extension
        this.selectedExtension = null
    },
    mounted() {
        //  Check if a extension is set in the url params
        const id = this.$route.query.id

        //  If a extension id is set, load it
        if (id) this.$store.dispatch('customFieldsSelectedExtensionOptionGet', id)

        //  Set mounted to true to tell our component we are ready
        this.mounted = true
    },
    computed: {
        customFieldsExtensionOptions(): ExtensionOption[] {
            return this.$store.getters.customFieldsExtensionOptions
        },
        selectedExtension: {
            get(): ExtensionOption {
                return this.$store.getters.customFieldsSelectedExtensionOption
            },
            set(val: ExtensionOption): void {
                this.$store.commit('customFieldsSelectedExtensionOptionSet', val)
            }
        }
    },
    methods: {
        extensionDelete(dialog_result: boolean, extension: ExtensionOption): void {
            //  If the user answer NO to dialog, do nothing
            if (!dialog_result) return

            //  Else, send the request to the API
            this.$store.dispatch('extensionOptionsDelete', extension.id)
        },
        extensionDeleteConfirm(extension: ExtensionOption): void {
            //  Pop a confirm dialog
            this.$store.dispatch('dialogOpen', {
                type: 'CONFIRM',
                title: 'Delete this custom field?',
                text: `Are you sure you want to delete this custom field?  You will lose all data associated with the custom field. <br><b>THIS CANNOT BE UNDONE!</b>`,
                icon: 'mdi-alert',
                color: 'red darken-2',
                admin: true,
                callback: (result: boolean) => this.extensionDelete(result, extension)
            })
        },
        async extensionUpdate(extension: ExtensionOption): Promise<void> {
            //  Prepare the extension data
            const payload = this.extensionPrep(extension)

            //  Update the extension then close the dialog
            const ext = await this.$store.dispatch('extensionOptionsPut', payload)

            //  If the request failed, do nothing
            if (!ext) return

            //  Else, close the app dialog
            this.$store.dispatch('dialogClose', 'APP')

            //  Notify the user of success
            this.$store.commit('appNotificationBarSet', {
                message: 'Custom Field Updated',
                type: 'success'
            })
        },
        extOptionsActions(extension: ExtensionOption): IListAction {
            //  Get our menu buttons
            const menu = this.extOptionsActionsMenu(extension)

            //  Create our list action
            const action: IListAction = {
                type: IListActionType.menu,
                menu: menu
            }

            //  Return the created action
            return action
        },
        extOptionsActionsMenu(
            extension: ExtensionOption,
            actions: boolean = true
        ): Button[] {
            //  Create our menu of buttons
            const menu: Button[] = [
                {
                    icon: 'mdi-pencil',
                    text: actions ? 'Edit Custom Field' : null,
                    tooltip: 'Edit Custom Field',
                    color: 'primary',
                    callback: () => this.goToExtensionEdit(extension)
                },
                {
                    icon: 'bi-trash-fill',
                    text: actions ? 'Delete Custom Field' : null,
                    tooltip: 'Delete Custom Field',
                    color: 'primary',
                    callback: () => this.extensionDeleteConfirm(extension)
                }
            ]

            //  Return the buttons
            return menu
        },
        extOptionsDescription(extension: ExtensionOption): string {
            //  If we are using a dropdown, then the description will include all items in it
            if (extension.type === 'dropdown' && extension.data) {
                return `Dropdown (${extension.data.toString()})`
            }

            //  Else we can just use the type of our extension
            return extension.type.toProperCase()
        },
        extOptionsIcon(): IListIcon {
            //  We always use the same icon
            const icon = 'mdi-format-annotation-plus'

            //  Construct our list icon
            const listIcon: IListIcon = {
                type: IListIconType.icon,
                content: icon,
                color: 'primary'
            }

            //  Return the created list icon
            return listIcon
        },
        extOptionsTile(): IListTile {
            return {
                actionContent: (ext: ExtensionOption) => this.extOptionsActions(ext),
                leftIcon: () => this.extOptionsIcon(),
                line1: (ext: ExtensionOption) => ext.name,
                line2: (ext: ExtensionOption) => this.extOptionsDescription(ext),
                callback: (ext: ExtensionOption) => this.onExtensionOptionSelected(ext)
            }
        },
        goToExtensionEdit(extension: ExtensionOption): void {
            //  Create an app form object
            const form = {
                title: 'Edit Custom Field',
                icon: 'mdi-format-annotation-plus',
                model: extension,
                inputs: this.$store.getters.extensionOptionInputs(extension)
            }

            this.$store.dispatch('dialogOpen', {
                type: 'APP',
                title: form.title,
                icon: form.icon,
                component: 'app-form',
                props: form,
                closeable: true,
                callback: (extension: ExtensionOption) => this.extensionUpdate(extension)
            })
        },
        onExtensionOptionSelected(extension: ExtensionOption): void {
            //  Set the step to 2 (for mobile layout only)
            this.$refs.customFieldsPanel.step = 2

            //  Check if the extension is different form the currently selected extension
            const isNew =
                !this.selectedExtension || this.selectedExtension.id != extension.id

            //  If the extension is NOT different from the current selected extension, do nothing
            if (!isNew) return

            //  Clone the current query params (we do this to avoid the Vue duplicate naviagtion error)
            const query = Object.assign({}, this.$route.query)

            //  Update the person query param (there is watcher on this value that handles fetching the person)
            query.id = extension.id

            //  Update the current url
            this.$router.push({ query })
        }
    },
    watch: {
        $route(to, from): void {
            //  If the 'id' query param does NOT exist, unset our data
            if (!to.query.id) return (this.selectedExtension = null)

            //  Get the extension id from the query param
            const id = to.query.id

            //  Check if the 'extension' param is different from the currently loaded campaign
            const needsLoad = !this.selectedExtension || id != this.selectedExtension.id

            //  If we do NOT need to load, do nothing
            if (!needsLoad) return

            //  Else, fetch the new extension
            this.$store.dispatch('customFieldsSelectedExtensionOptionGet', id)
        }
    }
})
